__turbopack_context__.v({
  "left": "ZCUs7q_left",
  "navButton": "ZCUs7q_navButton",
  "pageDots": "ZCUs7q_pageDots",
  "pageItem": "ZCUs7q_pageItem",
  "pages": "ZCUs7q_pages",
  "pagination": "ZCUs7q_pagination",
  "right": "ZCUs7q_right",
  "summary": "ZCUs7q_summary",
});
